module.exports = __webpack_public_path__ + "static/img/service_bg3.221b420b.png";